export default function onInView (elem: HTMLElement, callback: (observer: IntersectionObserver) => void, options: IntersectionObserverInit) {
  const observer = new IntersectionObserver(([ entry ]) => {
    if (!entry.isIntersecting) return
    callback(observer)
  }, options)
  observer.observe(elem)
}
